/*****
 * Created by Allan on 2023/02/15.
 * Contact 84880528@qq.com.
 * 储存token和appid
 * *****/
export default{
	state:{
		appList:JSON.parse(localStorage.getItem('appList')),
		activeApp:localStorage.getItem('activeApp') || 'HiPrestamos',
		appParams:JSON.parse(localStorage.getItem('appParams')) || {},
		gstAppParams:JSON.parse(localStorage.getItem('gstAppParams')) || {},
	},
	getters:{
		appList:state=>state.appList,
		activeApp:state=>state.activeApp,
		appParams:state=>state.appParams,
		gstAppParams:state=>state.gstAppParams,
	},
	mutations:{
		mutationsAppList(state,data){
			localStorage.setItem('appList',JSON.stringify(data));
			state.appList=data;
		},
		mutationsActiveApp(state,data){
			state.activeApp=data;
			localStorage.setItem('activeApp',data);
		},
		mutationsAppParams(state,data){
			state.appParams=data;
			localStorage.setItem('appParams',JSON.stringify(data));
		},
		mutationsGstAppParams(state,data){
			state.gstAppParams=data;
			localStorage.setItem('gstAppParams',JSON.stringify(data));
		},
	},
	actions:{
		actionsAppList({ commit }, data){
			commit('mutationsAppList',data)
		},
		actionsActiveApp({ commit }, data){
			commit('mutationsActiveApp',data)
		},
		actionsAppParams({ commit }, data){
			commit('mutationsAppParams',data)
		},
		actionsGstAppParams({ commit }, data){
			commit('mutationsGstAppParams',data)
		},
	},
}


// WEBPACK FOOTER //
// ./src/repayment/store/module/global.js